import createLucideIcon from '../createLucideIcon';

/**
 * @component @name Sunrise
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMnY4IiAvPgogIDxwYXRoIGQ9Im00LjkzIDEwLjkzIDEuNDEgMS40MSIgLz4KICA8cGF0aCBkPSJNMiAxOGgyIiAvPgogIDxwYXRoIGQ9Ik0yMCAxOGgyIiAvPgogIDxwYXRoIGQ9Im0xOS4wNyAxMC45My0xLjQxIDEuNDEiIC8+CiAgPHBhdGggZD0iTTIyIDIySDIiIC8+CiAgPHBhdGggZD0ibTggNiA0LTQgNCA0IiAvPgogIDxwYXRoIGQ9Ik0xNiAxOGE0IDQgMCAwIDAtOCAwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/sunrise
 * @see https://lucide.dev/guide/packages/lucide-preact - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sunrise = createLucideIcon('sunrise', [
  ['path', { d: 'M12 2v8', key: '1q4o3n' }],
  ['path', { d: 'm4.93 10.93 1.41 1.41', key: '2a7f42' }],
  ['path', { d: 'M2 18h2', key: 'j10viu' }],
  ['path', { d: 'M20 18h2', key: 'wocana' }],
  ['path', { d: 'm19.07 10.93-1.41 1.41', key: '15zs5n' }],
  ['path', { d: 'M22 22H2', key: '19qnx5' }],
  ['path', { d: 'm8 6 4-4 4 4', key: 'ybng9g' }],
  ['path', { d: 'M16 18a4 4 0 0 0-8 0', key: '1lzouq' }],
]);

export default Sunrise;
